import React, { Component } from 'react';
import LibraryList from '../LibraryList';
import NavigationTabs from '../nav/NavigationTabs'
import { COLORS } from '../../styles/colors';
import { EXERCISE_LIBRARY_MESSAGE } from '../../static-content';
import { paginationLimit } from './../../helpers.js'
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }
  componentDidMount() {
    const { user, fetchList, fetchFormFilterData } = this.props;
    fetchList({
      creatorId: (this.props.user.id || localStorage.id ),
      limit: paginationLimit.TEN,
      skip: 0,
      type: user.type
    }).then((res) => {
      this.setState({ dataLoaded: true });
    });
    fetchFormFilterData();
  }

  componentWillUnmount() {
    this.props.resetExercises();
  }

  render() {
    const { user, equipment, cats, isLoadMoreListing, fetchMoreExercises, resetExercises, exercises } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="Exercises"
          description={EXERCISE_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/exercises" />
        {this.state.dataLoaded &&
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
            <LibraryList
              items={Object.values(exercises)}
              categories={[]}
              equipment={equipment}
              bodyPart={cats}
              categoryField="equipmentId"
              itemType="exercise"
              user={user}
              isLoadMoreListing = {isLoadMoreListing}
              fetchMoreListing = {fetchMoreExercises}
              resetListing = {resetExercises}
            />
          </div>}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/exercises/List.js